import type { GetDisclosureTitleDTO } from '../service/ai-disclosure.repository.interface';
import type { GetDisclosureTitleRequest } from '../type/ai-disclosure.type';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { GetDisclosureTitle } from '@/infrastructure/api-functions/interface/get-disclosure-title.interface';

@injectable()
export class GetDisclosureTitleDTOImpl implements GetDisclosureTitleDTO {
    constructor(
        @inject(GetDisclosureTitle)
        private readonly _getDisclosureTitleApi: GetDisclosureTitle
    ) { }

    async fetch(value: GetDisclosureTitleRequest): Promise<string> {
        const params = {
            task_id: value.taskId,
            current_step: value.currentStep,
        };

        return await this._getDisclosureTitleApi.getDisclosureTitle(params);
    }
}
